/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeAppPassword.defs.js'
export * as $defs from './revokeAppPassword.defs.js'
